import { i18ntrans } from 'language/i18nkey';

export const useDisplayTarget = (): { getDisplayTargetStr: (displayTarget: number) => string } => {
  const getDisplayTargetStr = (displayTarget: number) => {
    const t = i18ntrans.adminstrict;

    if (displayTarget === 0) return t('I18N_POPUP_GUEST');
    if (displayTarget === 10) return t('I18N_POPUP_LOGIN');
    if (displayTarget === 15) return t('I18N_POPUP_PARTNER');
    if (displayTarget === 20) return t('I18N_POPUP_EMPLOYEE');
    return '-';
  };
  return { getDisplayTargetStr };
};
